import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef } from 'react';
export function DimensionAccordion({ controls, onSave, btnText = '->' }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const touchStartX = useRef(null);
    const prev = () => setActiveIndex(i => (i - 1 + controls.length) % controls.length);
    const next = () => setActiveIndex(i => (i + 1) % controls.length);
    const onTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };
    const onTouchEnd = (e) => {
        if (touchStartX.current === null)
            return;
        const dx = e.changedTouches[0].clientX - touchStartX.current;
        if (dx > 50)
            prev();
        else if (dx < -50)
            next();
        touchStartX.current = null;
    };
    const active = controls[activeIndex];
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: styles }), _jsxs("div", { className: "dim-accordion", onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, children: [_jsx("div", { className: "dim-accordion__dots", children: controls.map((c, i) => (_jsx("button", { className: `dim-accordion__dot ${i === activeIndex ? 'dim-accordion__dot--active' : ''}`, onClick: () => setActiveIndex(i), title: c.label }, i))) }), _jsx("div", { className: "dim-accordion__label", children: active.label }), _jsxs("div", { className: "dim-accordion__row", children: [_jsx("button", { className: "dim-accordion__nav dim-accordion__nav--prev", onClick: prev, children: "\u2039" }), _jsxs("div", { className: "dim-accordion__control", children: [_jsx("button", { className: "dim-accordion__btn", onClick: () => active.onChange(+(active.value - active.step).toFixed(4)), children: "\u2212" }), _jsx("input", { className: "dim-accordion__input", type: "number", value: active.value, onChange: e => active.onChange(Number(e.currentTarget.value)) }), _jsx("button", { className: "dim-accordion__btn", onClick: () => active.onChange(+(active.value + active.step).toFixed(4)), children: "+" })] }), _jsx("button", { className: "dim-accordion__nav dim-accordion__nav--next", onClick: next, children: "\u203A" })] }), _jsx("div", { className: "dim-accordion__progress", children: _jsx("div", { className: "dim-accordion__progress-fill", style: { width: `${((activeIndex + 1) / controls.length) * 100}%` } }) }), _jsxs("div", { className: "dim-accordion__counter", children: [activeIndex + 1, " / ", controls.length] }), onSave && (_jsx("button", { className: "dim-accordion__save", onClick: onSave, children: btnText }))] })] }));
}
const styles = `
.dim-accordion {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background: rgb(37 73 136 / 92%);
    padding: 14px 16px 12px;
    width: 100%;
    box-sizing: border-box;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

/* Dots */
.dim-accordion__dots {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;
}

.dim-accordion__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255 255 255 / 30%);
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s, transform 0.2s;
}

.dim-accordion__dot--active {
    background: #ffffff;
    transform: scale(1.3);
}

/* Label */
.dim-accordion__label {
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.8;
    min-height: 16px;
}

/* Row with nav arrows + control */
.dim-accordion__row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    justify-content: center;
}

/* Nav arrows (prev/next parameter) */
.dim-accordion__nav {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255 255 255 / 12%);
    border: 1px solid rgba(255 255 255 / 25%);
    color: #fff;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s;
}

.dim-accordion__nav:hover,
.dim-accordion__nav:active {
    background: rgba(255 255 255 / 28%);
}

/* Control: − value + */
.dim-accordion__control {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    max-width: 220px;
    justify-content: center;
}

.dim-accordion__btn {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(255 255 255 / 15%);
    border: 1px solid rgba(255 255 255 / 30%);
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s, transform 0.1s;
    -webkit-tap-highlight-color: transparent;
}

.dim-accordion__btn:active {
    background: rgba(255 255 255 / 35%);
    transform: scale(0.93);
}

.dim-accordion__input {
    width: 72px;
    height: 44px;
    text-align: center;
    border-radius: 10px;
    border: 1px solid rgba(255 255 255 / 40%);
    background: rgba(255 255 255 / 10%);
    color: #fff;
    font-size: 16px;
    padding: 0 6px;
    box-sizing: border-box;
    -moz-appearance: textfield;
}

.dim-accordion__input::-webkit-inner-spin-button,
.dim-accordion__input::-webkit-outer-spin-button {
    -webkit-appearance: none;
}

/* Progress bar */
.dim-accordion__progress {
    width: 100%;
    height: 3px;
    background: rgba(255 255 255 / 20%);
    border-radius: 2px;
    overflow: hidden;
}

.dim-accordion__progress-fill {
    height: 100%;
    background: #fff;
    border-radius: 2px;
    transition: width 0.25s ease;
}

/* Counter */
.dim-accordion__counter {
    font-size: 11px;
    color: rgba(255 255 255 / 50%);
}

/* Save button */
.dim-accordion__save {
    margin-top: 4px;
    width: 100%;
    height: 44px;
    border-radius: 10px;
    background: #fff;
    color: rgb(37 73 136);
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.04em;
    transition: opacity 0.15s;
}

.dim-accordion__save:active {
    opacity: 0.8;
}
.dim-accordion {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background: rgb(37 73 136 / 92%);
    padding: 14px 16px 12px;
    width: 100%;
    box-sizing: border-box;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

/* Dots */
.dim-accordion__dots {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;
}

.dim-accordion__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255 255 255 / 30%);
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s, transform 0.2s;
}

.dim-accordion__dot--active {
    background: #ffffff;
    transform: scale(1.3);
}

/* Label */
.dim-accordion__label {
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.8;
    min-height: 16px;
}

/* Row with nav arrows + control */
.dim-accordion__row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    justify-content: center;
}

/* Nav arrows (prev/next parameter) */
.dim-accordion__nav {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255 255 255 / 12%);
    border: 1px solid rgba(255 255 255 / 25%);
    color: #fff;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s;
}

.dim-accordion__nav:hover,
.dim-accordion__nav:active {
    background: rgba(255 255 255 / 28%);
}

/* Control: − value + */
.dim-accordion__control {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    max-width: 220px;
    justify-content: center;
}

.dim-accordion__btn {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(255 255 255 / 15%);
    border: 1px solid rgba(255 255 255 / 30%);
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s, transform 0.1s;
    -webkit-tap-highlight-color: transparent;
}

.dim-accordion__btn:active {
    background: rgba(255 255 255 / 35%);
    transform: scale(0.93);
}

.dim-accordion__input {
    width: 72px;
    height: 44px;
    text-align: center;
    border-radius: 10px;
    border: 1px solid rgba(255 255 255 / 40%);
    background: rgba(255 255 255 / 10%);
    color: #fff;
    font-size: 16px;
    padding: 0 6px;
    box-sizing: border-box;
    -moz-appearance: textfield;
}

.dim-accordion__input::-webkit-inner-spin-button,
.dim-accordion__input::-webkit-outer-spin-button {
    -webkit-appearance: none;
}

/* Progress bar */
.dim-accordion__progress {
    width: 100%;
    height: 3px;
    background: rgba(255 255 255 / 20%);
    border-radius: 2px;
    overflow: hidden;
}

.dim-accordion__progress-fill {
    height: 100%;
    background: #fff;
    border-radius: 2px;
    transition: width 0.25s ease;
}

/* Counter */
.dim-accordion__counter {
    font-size: 11px;
    color: rgba(255 255 255 / 50%);
}

/* Save button */
.dim-accordion__save {
    margin-top: 4px;
    width: 100%;
    height: 44px;
    border-radius: 10px;
    background: #fff;
    color: rgb(37 73 136);
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.04em;
    transition: opacity 0.15s;
}

.dim-accordion__save:active {
    opacity: 0.8;
}

`;
